var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthenticity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2053",
    "data-name": "Rettangolo 2053",
    width: 21.63,
    height: 16.897,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8955",
    "data-name": "Tracciato 8955",
    d: "M50.59,25.217l-2.435-1.768.4,2.73-2.739-.306,1.41,1.315-4.886,1.131,5.255,1.624-2.782,3.464L49.8,31.61l-.332,1.441,1.167-1.083,1.286,3.677L53.2,32.087l.954.954.179-.954,3.4,2.324L56.3,30.776l1.818.417-1.281-1.43L61.5,28.591l-3.723-1.526,2.068-2.7-4.327,1.284L56.3,23l-3.049,1.849L52.12,20.8Z",
    transform: "translate(-42.338 -20.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.068,
    y1: 1.05,
    x2: -0.066,
    y2: 1.05,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be093d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0049"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8958",
    "data-name": "Tracciato 8958",
    d: "M39.361,16.337a.414.414,0,0,0,.134.2l4.2,3.424-3.635-4.023a.4.4,0,0,0-.3-.139.415.415,0,0,0-.4.54",
    transform: "translate(-39.341 -15.797)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.336,
    y1: 3.909,
    x2: -0.327,
    y2: 3.909,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8961",
    "data-name": "Tracciato 8961",
    d: "M445.768,308.218a.281.281,0,1,0,.264-.493l-3.131-1.357Z",
    transform: "translate(-442.901 -306.368)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5.237,
    y1: 2.376,
    x2: -5.225,
    y2: 2.376,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8964",
    "data-name": "Tracciato 8964",
    d: "M6.4,266.542a.31.31,0,1,0,.288.547l4.88-2.928Z",
    transform: "translate(-6.207 -264.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.023,
    y1: 2.152,
    x2: -0.016,
    y2: 2.152,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8966",
    "data-name": "Tracciato 8966",
    d: "M427.33,52.05a.261.261,0,0,0-.17.089l-1.7,1.969,2.058-1.592a.261.261,0,0,0-.157-.467l-.03,0",
    transform: "translate(-425.458 -52.048)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -7.483,
    y1: 7.201,
    x2: -7.465,
    y2: 7.201,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8970",
    "data-name": "Tracciato 8970",
    d: "M107.442,144.521l.614,2.938-.775,1.63,1.125.073a44.2,44.2,0,0,1,2.5-5.013l-1.177-.2-.84,1.768a7.75,7.75,0,0,1-.051-1.008q.007-.5.029-.84Z",
    transform: "translate(-107.281 -143.863)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.176,
    y1: 2.111,
    x2: -1.165,
    y2: 2.111,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52e5ec"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8972",
    "data-name": "Tracciato 8972",
    d: "M170.16,138.142l-.87,5.24a16.665,16.665,0,0,1,2.667-.5l.1-1.359-1.36.2.055-.285q.022-.146.051-.292.474-.11,1.305-.256l.066-1.009-1.169.248.08-.4q.044-.205.1-.418.6-.095,1.316-.16l.1-1.358Z",
    transform: "translate(-169.29 -137.784)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.035,
    y1: 2.041,
    x2: -2.023,
    y2: 2.041,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8974",
    "data-name": "Tracciato 8974",
    d: "M226.561,139.47h.007l-.336,2.759-.359.07Zm-.884-.57a47.307,47.307,0,0,1-1.739,5.284l1.535-.234.153-.643.49-.1-.11.913,1.549-.358a29.3,29.3,0,0,1,.343-5.24Z",
    transform: "translate(-223.938 -138.527)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.245,
    y1: 2.015,
    x2: -2.235,
    y2: 2.015,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8976",
    "data-name": "Tracciato 8976",
    d: "M316.171,142.992l-.373,2.185-.607.124q.226-1.147.592-2.543l-1.352.234-.884,5.167,1.257-.322q.058-.636.2-1.535l.621-.132-.336,1.988,1.257-.322a34.074,34.074,0,0,1,.979-5.079Z",
    transform: "translate(-313.547 -142.758)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3.132,
    y1: 2.079,
    x2: -3.122,
    y2: 2.079,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8978",
    "data-name": "Tracciato 8978",
    d: "M396.385,138.655a1.2,1.2,0,0,0-.614.27.81.81,0,0,0-.343.621.386.386,0,0,0,.227.365.762.762,0,0,0,.453.058,1.228,1.228,0,0,0,.607-.263.782.782,0,0,0,.358-.614.385.385,0,0,0-.234-.365.666.666,0,0,0-.329-.082.88.88,0,0,0-.124.009m-.241-.811,1.016.044a14.424,14.424,0,0,1,.687-1.82q.285-.614.892-1.7l-1.527-.256Z",
    transform: "translate(-395.428 -134.11)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2.33,
    y1: 2.784,
    x2: -2.323,
    y2: 2.784,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2044",
    "data-name": "Rettangolo 2044",
    width: 1.296,
    height: 1.733,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2045",
    "data-name": "Rettangolo 2045",
    width: 0.865,
    height: 0.614,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2046",
    "data-name": "Rettangolo 2046",
    width: 0.846,
    height: 2.126,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2047",
    "data-name": "Rettangolo 2047",
    width: 1.254,
    height: 2.033,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2048",
    "data-name": "Rettangolo 2048",
    width: 1.461,
    height: 1.92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2051",
    "data-name": "Rettangolo 2051",
    width: 1.568,
    height: 2.659,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5590",
    "data-name": "Raggruppa 5590",
    transform: "translate(-1493 -167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2498",
    "data-name": "Rettangolo 2498",
    width: 24,
    height: 24,
    transform: "translate(1493 167)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_554",
    "data-name": "Ellisse 554",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1495 169)",
    fill: "#f5f1ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5530",
    "data-name": "Raggruppa 5530",
    transform: "translate(1493.976 171.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4733",
    "data-name": "Raggruppa 4733",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4668",
    "data-name": "Raggruppa 4668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4667",
    "data-name": "Raggruppa 4667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8908",
    "data-name": "Tracciato 8908",
    d: "M314.262,323.194a.347.347,0,1,1,.455.185.347.347,0,0,1-.455-.185",
    transform: "translate(-301.754 -309.896)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8909",
    "data-name": "Tracciato 8909",
    d: "M323.735,345.055a.331.331,0,1,1,.433.176.33.33,0,0,1-.433-.176",
    transform: "translate(-310.853 -330.91)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8910",
    "data-name": "Tracciato 8910",
    d: "M334.453,368.1a.264.264,0,1,1,.346.141.264.264,0,0,1-.346-.141",
    transform: "translate(-321.15 -353.123)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8911",
    "data-name": "Tracciato 8911",
    d: "M344.469,389.469a.2.2,0,1,1,.26.106.2.2,0,0,1-.26-.106",
    transform: "translate(-330.773 -373.736)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8912",
    "data-name": "Tracciato 8912",
    d: "M291.193,332.929a.347.347,0,1,1,.455.185.347.347,0,0,1-.455-.185",
    transform: "translate(-279.601 -319.244)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8913",
    "data-name": "Tracciato 8913",
    d: "M300.667,354.789a.33.33,0,1,1,.433.176.33.33,0,0,1-.433-.176",
    transform: "translate(-288.701 -340.258)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8914",
    "data-name": "Tracciato 8914",
    d: "M311.385,377.83a.264.264,0,1,1,.346.141.264.264,0,0,1-.346-.141",
    transform: "translate(-298.998 -362.471)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8915",
    "data-name": "Tracciato 8915",
    d: "M267.422,342.96a.347.347,0,1,1,.455.185.347.347,0,0,1-.455-.185",
    transform: "translate(-256.775 -328.876)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8916",
    "data-name": "Tracciato 8916",
    d: "M276.9,364.821a.331.331,0,1,1,.433.176.33.33,0,0,1-.433-.176",
    transform: "translate(-265.873 -349.891)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8917",
    "data-name": "Tracciato 8917",
    d: "M384.466,294.4a.347.347,0,1,1,.455.185.347.347,0,0,1-.455-.185",
    transform: "translate(-369.17 -282.241)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8918",
    "data-name": "Tracciato 8918",
    d: "M393.94,316.258a.331.331,0,1,1,.433.176.33.33,0,0,1-.433-.176",
    transform: "translate(-378.269 -303.257)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8919",
    "data-name": "Tracciato 8919",
    d: "M404.659,339.3a.264.264,0,1,1,.346.141.264.264,0,0,1-.346-.141",
    transform: "translate(-388.567 -325.47)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8920",
    "data-name": "Tracciato 8920",
    d: "M409.324,283.907a.347.347,0,1,1,.455.185.347.347,0,0,1-.455-.185",
    transform: "translate(-393.041 -272.169)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8921",
    "data-name": "Tracciato 8921",
    d: "M418.8,305.768a.331.331,0,1,1,.433.176.331.331,0,0,1-.433-.176",
    transform: "translate(-402.14 -293.183)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8922",
    "data-name": "Tracciato 8922",
    d: "M361.4,304.131a.347.347,0,1,1,.455.185.347.347,0,0,1-.455-.185",
    transform: "translate(-347.018 -291.59)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8923",
    "data-name": "Tracciato 8923",
    d: "M370.871,325.992a.331.331,0,1,1,.433.176.33.33,0,0,1-.433-.176",
    transform: "translate(-356.117 -312.604)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8924",
    "data-name": "Tracciato 8924",
    d: "M381.591,349.033a.264.264,0,1,1,.346.141.264.264,0,0,1-.346-.141",
    transform: "translate(-366.415 -334.818)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8925",
    "data-name": "Tracciato 8925",
    d: "M391.605,370.407a.2.2,0,1,1,.26.106.2.2,0,0,1-.26-.106",
    transform: "translate(-376.037 -355.431)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8926",
    "data-name": "Tracciato 8926",
    d: "M337.627,314.162a.347.347,0,1,1,.455.185.347.347,0,0,1-.455-.185",
    transform: "translate(-324.191 -301.222)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8927",
    "data-name": "Tracciato 8927",
    d: "M347.1,336.023a.331.331,0,1,1,.433.176.33.33,0,0,1-.433-.176",
    transform: "translate(-333.29 -322.237)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8928",
    "data-name": "Tracciato 8928",
    d: "M357.819,359.064a.264.264,0,1,1,.346.141.264.264,0,0,1-.346-.141",
    transform: "translate(-343.587 -344.451)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8929",
    "data-name": "Tracciato 8929",
    d: "M367.835,380.438a.2.2,0,1,1,.26.106.2.2,0,0,1-.26-.106",
    transform: "translate(-353.211 -365.064)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8930",
    "data-name": "Tracciato 8930",
    d: "M377.146,400.145a.132.132,0,1,1,.173.07.132.132,0,0,1-.173-.07",
    transform: "translate(-362.157 -384.076)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8931",
    "data-name": "Tracciato 8931",
    d: "M246.656,93.427a.347.347,0,1,1-.455-.185.347.347,0,0,1,.455.185",
    transform: "translate(-236.22 -89.512)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8932",
    "data-name": "Tracciato 8932",
    d: "M237.982,72.365a.33.33,0,1,1-.433-.176.33.33,0,0,1,.433.176",
    transform: "translate(-227.92 -69.297)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8933",
    "data-name": "Tracciato 8933",
    d: "M230.46,52.522a.264.264,0,1,1-.346-.141.264.264,0,0,1,.346.141",
    transform: "translate(-220.819 -50.281)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8934",
    "data-name": "Tracciato 8934",
    d: "M223.642,34.345a.2.2,0,1,1-.26-.106.2.2,0,0,1,.26.106",
    transform: "translate(-214.394 -32.865)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8935",
    "data-name": "Tracciato 8935",
    d: "M269.724,83.692a.347.347,0,1,1-.455-.185.347.347,0,0,1,.455.185",
    transform: "translate(-258.372 -80.164)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8936",
    "data-name": "Tracciato 8936",
    d: "M261.049,62.63a.331.331,0,1,1-.433-.176.33.33,0,0,1,.433.176",
    transform: "translate(-250.071 -59.949)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8937",
    "data-name": "Tracciato 8937",
    d: "M253.528,42.787a.264.264,0,1,1-.346-.141.264.264,0,0,1,.346.141",
    transform: "translate(-242.971 -40.932)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8938",
    "data-name": "Tracciato 8938",
    d: "M293.5,73.661a.347.347,0,1,1-.455-.185.347.347,0,0,1,.455.185",
    transform: "translate(-281.199 -70.531)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8939",
    "data-name": "Tracciato 8939",
    d: "M284.821,52.6a.331.331,0,1,1-.433-.176.33.33,0,0,1,.433.176",
    transform: "translate(-272.899 -50.316)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8940",
    "data-name": "Tracciato 8940",
    d: "M176.451,122.224a.347.347,0,1,1-.455-.185.347.347,0,0,1,.455.185",
    transform: "translate(-168.803 -117.166)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8941",
    "data-name": "Tracciato 8941",
    d: "M167.776,101.162a.331.331,0,1,1-.433-.176.33.33,0,0,1,.433.176",
    transform: "translate(-160.503 -96.95)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8942",
    "data-name": "Tracciato 8942",
    d: "M160.255,81.319a.264.264,0,1,1-.346-.141.264.264,0,0,1,.346.141",
    transform: "translate(-153.403 -77.934)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8943",
    "data-name": "Tracciato 8943",
    d: "M151.593,132.714a.347.347,0,1,1-.455-.185.347.347,0,0,1,.455.185",
    transform: "translate(-144.932 -127.239)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8944",
    "data-name": "Tracciato 8944",
    d: "M142.918,111.652a.33.33,0,1,1-.433-.176.33.33,0,0,1,.433.176",
    transform: "translate(-136.632 -107.023)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8945",
    "data-name": "Tracciato 8945",
    d: "M199.519,112.49a.347.347,0,1,1-.455-.185.347.347,0,0,1,.455.185",
    transform: "translate(-190.955 -107.818)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8946",
    "data-name": "Tracciato 8946",
    d: "M190.845,91.428a.331.331,0,1,1-.433-.176.331.331,0,0,1,.433.176",
    transform: "translate(-182.655 -87.603)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8947",
    "data-name": "Tracciato 8947",
    d: "M183.323,71.584a.264.264,0,1,1-.346-.141.264.264,0,0,1,.346.141",
    transform: "translate(-175.554 -68.586)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8948",
    "data-name": "Tracciato 8948",
    d: "M176.505,53.408a.2.2,0,1,1-.26-.106.2.2,0,0,1,.26.106",
    transform: "translate(-169.129 -51.171)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8949",
    "data-name": "Tracciato 8949",
    d: "M223.291,102.459a.347.347,0,1,1-.455-.185.347.347,0,0,1,.455.185",
    transform: "translate(-213.783 -98.186)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8950",
    "data-name": "Tracciato 8950",
    d: "M214.616,81.4a.331.331,0,1,1-.433-.176.33.33,0,0,1,.433.176",
    transform: "translate(-205.483 -77.969)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8951",
    "data-name": "Tracciato 8951",
    d: "M207.095,61.553a.264.264,0,1,1-.346-.141.264.264,0,0,1,.346.141",
    transform: "translate(-198.382 -58.953)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8952",
    "data-name": "Tracciato 8952",
    d: "M200.277,43.376a.2.2,0,1,1-.26-.106.2.2,0,0,1,.26.106",
    transform: "translate(-191.957 -41.537)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8953",
    "data-name": "Tracciato 8953",
    d: "M194.162,26.866a.132.132,0,1,1-.173-.07.132.132,0,0,1,.173.07",
    transform: "translate(-186.206 -25.722)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8954",
    "data-name": "Tracciato 8954",
    d: "M69.28,43.907l1.529-4.417,1.126,4.047,3.049-1.849-.777,2.647,4.327-1.284-2.068,2.7,3.723,1.526-4.668,1.171,1.281,1.43-1.818-.417,1.43,3.636-3.4-2.324-.179.954-.954-.954-1.277,3.558-1.286-3.677-1.166,1.083.332-1.441L63.5,52.1l2.782-3.464-5.255-1.624,4.886-1.131L64.5,44.562l2.739.306-.4-2.729Z",
    transform: "translate(-58.604 -37.922)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4670",
    "data-name": "Raggruppa 4670",
    transform: "translate(1.681 0.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4669",
    "data-name": "Raggruppa 4669",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2025",
    "data-name": "Rettangolo 2025",
    width: 19.831,
    height: 15.72,
    transform: "translate(-0.689 0.032) rotate(-2.663)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4672",
    "data-name": "Raggruppa 4672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4671",
    "data-name": "Raggruppa 4671",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8956",
    "data-name": "Tracciato 8956",
    d: "M29.295.826l1.126,4.047L33.47,3.024l-.777,2.647L37.02,4.387l-2.068,2.7,3.723,1.526L34.006,9.789l1.281,1.43L33.47,10.8l1.43,3.636-3.4-2.324-.179.954-.954-.954-1.277,3.558-1.286-3.677-1.167,1.083.332-1.441-4.987,1.795,2.782-3.464L19.513,8.344,24.4,7.213,22.989,5.9l2.739.306-.4-2.729,2.435,1.768ZM29.32,0l-.258.746-1.421,4.1L25.475,3.275,25,2.932l.084.578.351,2.414-2.423-.271-.739-.083.544.507,1.072,1L19.458,8.1l-.889.206.871.269L24.349,10.1l-2.555,3.181-.548.682.823-.3,4.563-1.642-.231,1-.18.781.587-.545.891-.827,1.162,3.322.229.656.235-.654,1.146-3.193.679.679.33.33.086-.459.109-.583,3.086,2.111.661.452-.293-.746-1.26-3.2,1.363.313.756.173-.517-.578L34.462,9.928l4.273-1.072.727-.182-.693-.284-3.426-1.4,1.873-2.449.459-.6-.725.215L33.057,5.306l.65-2.213.179-.609-.542.329L30.571,4.494,29.532.76Z",
    transform: "translate(-17.832)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8957",
    "data-name": "Tracciato 8957",
    d: "M106.661,14.664l-2.5-3.831a.351.351,0,1,1,.613-.336Z",
    transform: "translate(-99.97 -9.88)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4674",
    "data-name": "Raggruppa 4674",
    transform: "translate(1.562 0.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4673",
    "data-name": "Raggruppa 4673",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2027",
    "data-name": "Rettangolo 2027",
    width: 4.431,
    height: 4.162,
    transform: "translate(-0.073 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4676",
    "data-name": "Raggruppa 4676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4675",
    "data-name": "Raggruppa 4675",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8959",
    "data-name": "Tracciato 8959",
    d: "M33.82,9.847a.4.4,0,0,1,.3.139l3.635,4.023-4.2-3.424a.416.416,0,0,1,.267-.738m0-.246h0a.677.677,0,0,0-.542.275.649.649,0,0,0-.094.584.658.658,0,0,0,.214.316L37.6,14.2a.246.246,0,0,0,.338-.356L34.3,9.821a.648.648,0,0,0-.485-.22",
    transform: "translate(-31.836 -9.22)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8960",
    "data-name": "Tracciato 8960",
    d: "M425.458,310.107l3.434,3.083a.392.392,0,1,1-.569.535Z",
    transform: "translate(-408.561 -297.791)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4678",
    "data-name": "Raggruppa 4678",
    transform: "translate(17.59 12.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4677",
    "data-name": "Raggruppa 4677",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2029",
    "data-name": "Rettangolo 2029",
    width: 3.359,
    height: 1.99,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4680",
    "data-name": "Raggruppa 4680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4679",
    "data-name": "Raggruppa 4679",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8962",
    "data-name": "Tracciato 8962",
    d: "M436.95,300.417l3.131,1.357a.281.281,0,1,1-.264.493Zm0-.246a.246.246,0,0,0-.134.453l2.867,1.85a.525.525,0,0,0,.285.085.533.533,0,0,0,.422-.211.527.527,0,0,0-.212-.8l-3.131-1.357a.245.245,0,0,0-.1-.02",
    transform: "translate(-419.36 -288.249)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8963",
    "data-name": "Tracciato 8963",
    d: "M106.71,357.142l-3.177,2.145a.31.31,0,1,0,.386.483Z",
    transform: "translate(-99.289 -342.958)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4682",
    "data-name": "Raggruppa 4682",
    transform: "translate(0.247 10.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4681",
    "data-name": "Raggruppa 4681",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2031",
    "data-name": "Rettangolo 2031",
    width: 5.476,
    height: 2.976,
    transform: "translate(-0.12)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4684",
    "data-name": "Raggruppa 4684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4683",
    "data-name": "Raggruppa 4683",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8965",
    "data-name": "Tracciato 8965",
    d: "M5.6,258.211l-4.88,2.928a.31.31,0,0,1-.166.048h0a.31.31,0,0,1-.118-.6Zm0-.246a.245.245,0,0,0-.1.023L.335,260.366a.556.556,0,0,0,.215,1.066H.557a.556.556,0,0,0,.295-.084l4.878-2.926a.246.246,0,0,0-.127-.457",
    transform: "translate(0 -247.72)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4686",
    "data-name": "Raggruppa 4686",
    transform: "translate(16.897 2.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4685",
    "data-name": "Raggruppa 4685",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2033",
    "data-name": "Rettangolo 2033",
    width: 2.258,
    height: 2.059,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4688",
    "data-name": "Raggruppa 4688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4687",
    "data-name": "Raggruppa 4687",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8967",
    "data-name": "Tracciato 8967",
    d: "M421.409,46.1a.261.261,0,0,1,.157.467l-2.059,1.592,1.7-1.969a.261.261,0,0,1,.17-.089l.03,0m0-.246v0h0l-.055,0a.505.505,0,0,0-.331.173L419.321,48a.246.246,0,0,0,.337.356l2.059-1.592a.507.507,0,0,0-.307-.908",
    transform: "translate(-402.61 -44.031)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8968",
    "data-name": "Tracciato 8968",
    d: "M61.573,259.4l-2.474.807a.261.261,0,1,1-.111-.507Z",
    transform: "translate(-56.423 -249.102)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8969",
    "data-name": "Tracciato 8969",
    d: "M455.049,44.466l2.991-2.032a.334.334,0,1,1,.321.581Z",
    transform: "translate(-436.976 -40.692)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4690",
    "data-name": "Raggruppa 4690",
    transform: "translate(4.261 5.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4689",
    "data-name": "Raggruppa 4689",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2035",
    "data-name": "Rettangolo 2035",
    width: 3.625,
    height: 5.298,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4692",
    "data-name": "Raggruppa 4692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4691",
    "data-name": "Raggruppa 4691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8971",
    "data-name": "Tracciato 8971",
    d: "M99.726,134.268q-.022.336-.029.84a7.748,7.748,0,0,0,.051,1.008l.84-1.769,1.177.2a44.19,44.19,0,0,0-2.5,5.013l-1.125-.073.775-1.63-.614-2.938Zm.272-.4-.376.173L98.2,134.7l-.178.082.04.192.6,2.857-.739,1.555-.156.328.362.023,1.125.073.176.011.067-.164a44.146,44.146,0,0,1,2.485-4.985l.173-.3-.345-.06-1.177-.2-.184-.032-.08.169-.423.891c0-.007,0-.015,0-.022,0-.329.014-.608.029-.828Z",
    transform: "translate(-93.879 -128.554)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4694",
    "data-name": "Raggruppa 4694",
    transform: "translate(6.724 5.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4693",
    "data-name": "Raggruppa 4693",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2037",
    "data-name": "Rettangolo 2037",
    width: 3.304,
    height: 5.598,
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4696",
    "data-name": "Raggruppa 4696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4695",
    "data-name": "Raggruppa 4695",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8973",
    "data-name": "Tracciato 8973",
    d: "M165.226,130.82l-.1,1.358q-.716.066-1.316.16-.058.213-.1.418l-.08.4,1.169-.248-.066,1.009q-.831.146-1.305.256-.029.146-.051.292l-.055.285,1.36-.2-.095,1.359a16.665,16.665,0,0,0-2.667.5l.87-5.24Zm.267-.288-.3.045-2.434.358-.178.026-.029.177-.87,5.24-.062.373.366-.094a16.509,16.509,0,0,1,2.626-.5l.21-.018.015-.211.1-1.359.021-.3-.3.044-1.019.148q.006-.04.013-.079c.293-.064.674-.137,1.136-.218l.19-.034.013-.193.066-1.009.021-.324-.318.068-.8.171.007-.035c.017-.081.037-.164.058-.248.35-.052.733-.1,1.141-.134l.208-.019.015-.209.1-1.358Z",
    transform: "translate(-155.199 -125.348)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4698",
    "data-name": "Raggruppa 4698",
    transform: "translate(8.894 5.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4697",
    "data-name": "Raggruppa 4697",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2039",
    "data-name": "Rettangolo 2039",
    width: 3.961,
    height: 5.656,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4700",
    "data-name": "Raggruppa 4700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4699",
    "data-name": "Raggruppa 4699",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8975",
    "data-name": "Tracciato 8975",
    d: "M218.593,131.271a29.3,29.3,0,0,0-.343,5.24l-1.549.358.11-.913-.49.095-.153.643-1.535.234a47.322,47.322,0,0,0,1.739-5.284Zm-1.33.943h-.007l-.687,2.828.359-.07Zm1.631-1.243-.342.057-2.222.373-.157.026-.04.154a47.3,47.3,0,0,1-1.73,5.256l-.156.4.422-.064,1.535-.234.164-.025.038-.161.117-.489h0l-.069.578-.042.348.342-.079,1.549-.358.193-.045,0-.2a29.2,29.2,0,0,1,.34-5.2Z",
    transform: "translate(-205.738 -125.769)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4702",
    "data-name": "Raggruppa 4702",
    transform: "translate(12.453 5.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4701",
    "data-name": "Raggruppa 4701",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2041",
    "data-name": "Rettangolo 2041",
    width: 3.975,
    height: 5.4,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4704",
    "data-name": "Raggruppa 4704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4703",
    "data-name": "Raggruppa 4703",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8977",
    "data-name": "Tracciato 8977",
    d: "M310.111,135.32a34.054,34.054,0,0,0-.979,5.079l-1.257.322.336-1.988-.621.132q-.139.9-.2,1.535l-1.257.322.884-5.167,1.352-.234q-.365,1.4-.592,2.543l.607-.124.373-2.185Zm-1.4-.308-.377.065-1.352.234-.171.03-.029.171-.884,5.167-.064.374.368-.094,1.257-.322.168-.043.016-.173c.035-.377.092-.831.17-1.351l.1-.021-.276,1.631-.063.373.367-.094,1.257-.322.167-.043.017-.172a33.983,33.983,0,0,1,.973-5.041l.1-.369-.376.065-1.352.234-.093.016Zm-.611,2.535c.086-.41.185-.846.3-1.3l-.219,1.286Z",
    transform: "translate(-293.683 -129.65)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4706",
    "data-name": "Raggruppa 4706",
    transform: "translate(15.705 5.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4705",
    "data-name": "Raggruppa 4705",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2043",
    "data-name": "Rettangolo 2043",
    width: 6.135,
    height: 3.778,
    transform: "translate(-0.477 5.846) rotate(-85.333)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4732",
    "data-name": "Raggruppa 4732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4731",
    "data-name": "Raggruppa 4731",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8979",
    "data-name": "Tracciato 8979",
    d: "M391.26,127.364l1.527.256q-.607,1.089-.892,1.7a14.42,14.42,0,0,0-.687,1.82l-1.016-.044Zm-.7,4.536a.666.666,0,0,1,.329.082.385.385,0,0,1,.234.365.782.782,0,0,1-.358.614,1.228,1.228,0,0,1-.607.263,1.02,1.02,0,0,1-.14.01.69.69,0,0,1-.313-.069.386.386,0,0,1-.227-.365.81.81,0,0,1,.343-.621,1.2,1.2,0,0,1,.614-.27.877.877,0,0,1,.124-.009m.525-4.815-.06.211-1.067,3.734-.086.3.312.013,1.016.044.19.008.056-.182a14.246,14.246,0,0,1,.675-1.789c.186-.4.484-.969.883-1.686l.17-.3-.344-.058-1.527-.256Zm-.525,4.569h0a1.13,1.13,0,0,0-.157.011,1.451,1.451,0,0,0-.736.324h0a1.046,1.046,0,0,0-.432.811.633.633,0,0,0,.36.584h0a.937.937,0,0,0,.423.094,1.27,1.27,0,0,0,.173-.012,1.477,1.477,0,0,0,.725-.313,1.017,1.017,0,0,0,.453-.808.631.631,0,0,0-.365-.583.912.912,0,0,0-.444-.111",
    transform: "translate(-373.772 -122.038)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4709",
    "data-name": "Raggruppa 4709",
    transform: "translate(17.102 5.481)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4708",
    "data-name": "Raggruppa 4708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4707",
    "data-name": "Raggruppa 4707",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8980",
    "data-name": "Tracciato 8980",
    d: "M430.605,139.707l.5-1.7.771.14a.025.025,0,0,1,0,.049h-.655l-.568,1.528a.025.025,0,0,1-.047-.016",
    transform: "translate(-430.604 -138.006)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4712",
    "data-name": "Raggruppa 4712",
    transform: "translate(15.836 9.955)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4711",
    "data-name": "Raggruppa 4711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4710",
    "data-name": "Raggruppa 4710",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8981",
    "data-name": "Tracciato 8981",
    d: "M398.735,251.237a1,1,0,0,1,.843-.588.018.018,0,0,1,.008.035,2.005,2.005,0,0,0-.822.573.018.018,0,0,1-.03-.019",
    transform: "translate(-398.734 -250.648)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4715",
    "data-name": "Raggruppa 4715",
    transform: "translate(4.546 6.053)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4714",
    "data-name": "Raggruppa 4714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4713",
    "data-name": "Raggruppa 4713",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8982",
    "data-name": "Tracciato 8982",
    d: "M115.266,152.406l-.809.379.358,1.724a.026.026,0,0,0,.051-.009l-.2-1.584.626-.466a.026.026,0,0,0-.027-.044",
    transform: "translate(-114.457 -152.404)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4718",
    "data-name": "Raggruppa 4718",
    transform: "translate(7.398 5.794)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4717",
    "data-name": "Raggruppa 4717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4716",
    "data-name": "Raggruppa 4716",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8983",
    "data-name": "Tracciato 8983",
    d: "M187.492,145.875l-.913.143-.308,1.863a.023.023,0,0,0,.045.009l.415-1.678.775-.282a.029.029,0,0,0-.014-.055",
    transform: "translate(-186.27 -145.875)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4721",
    "data-name": "Raggruppa 4721",
    transform: "translate(10.235 5.825)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4720",
    "data-name": "Raggruppa 4720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4719",
    "data-name": "Raggruppa 4719",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8984",
    "data-name": "Tracciato 8984",
    d: "M259.128,146.676l-.913.143-.514,1.738a.031.031,0,0,0,.058.02l.608-1.563.775-.282a.029.029,0,0,0-.014-.055",
    transform: "translate(-257.7 -146.676)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4724",
    "data-name": "Raggruppa 4724",
    transform: "translate(13.186 5.825)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4723",
    "data-name": "Raggruppa 4723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4722",
    "data-name": "Raggruppa 4722",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8985",
    "data-name": "Tracciato 8985",
    d: "M333.235,146.676l-.913.143-.308,1.863a.023.023,0,0,0,.045.009l.415-1.678.775-.282a.029.029,0,0,0-.014-.055",
    transform: "translate(-332.013 -146.676)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4727",
    "data-name": "Raggruppa 4727",
    transform: "translate(14.882 5.898)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4726",
    "data-name": "Raggruppa 4726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4725",
    "data-name": "Raggruppa 4725",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8986",
    "data-name": "Tracciato 8986",
    d: "M375.921,148.511l-.913.143-.308,1.863a.023.023,0,0,0,.045.009l.415-1.678.775-.282a.029.029,0,0,0-.014-.055",
    transform: "translate(-374.699 -148.511)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4730",
    "data-name": "Raggruppa 4730",
    transform: "translate(4.969 8.207)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4729",
    "data-name": "Raggruppa 4729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4728",
    "data-name": "Raggruppa 4728",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8987",
    "data-name": "Tracciato 8987",
    d: "M126.67,206.692l-1.279,2.621H125.1l1.519-2.645a.026.026,0,0,1,.046.024",
    transform: "translate(-125.105 -206.654)",
    fill: "#fff"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticity);
export default __webpack_public_path__ + "static/media/authenticity.8f831087dc1d2d2441bda4bdc2025462.svg";
export { ForwardRef as ReactComponent };